export const FETCH_NUMBERS = 'FETCH_NUMBERS';
export const DONE_FETCHING_NUMBERS = 'DONE_FETCHING_NUMBERS';
export const ERROR_FETCHING_NUMBERS = 'ERROR_FETCHING_NUMBERS';
export const UNLINK_NUMBER_FROM_CAMPAIGN = 'UNLINK_NUMBER_FROM_CAMPAIGN';
export const UPDATE_NUMBER = 'UPDATE_NUMBER';
export const SHOW_NUMBERS_STATUS = 'SHOW NUMBER STATUS'
export const SHOW_BULK_SMS_NUMBERS_STATUS = 'SHOW_BULK_SMS_NUMBERS_STATUS';
